import React from 'react';
import { Icon } from './Icon.jsx';

const SHORTCUTS = [
  { keys: 'N', label: 'Open log time form' },
  { keys: '← →', label: 'Navigate days' },
  { keys: 'T', label: 'Jump to today' },
  { keys: '⌘ Enter', label: 'Save current entry' },
  { keys: 'Esc', label: 'Close form or dialog' },
  { keys: '?', label: 'Show this help' },
];

export function HelpDialog({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="tt-modal-backdrop" onClick={onClose}>
      <div
        className="tt-modal"
        style={{ maxWidth: 460, marginTop: '12vh' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            padding: '20px 24px 12px',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            borderBottom: '1px solid var(--sp-border)',
          }}
        >
          <h2 style={{ flex: 1, fontSize: 18, fontWeight: 700 }}>
            Keyboard shortcuts
          </h2>
          <button
            className="btn btn-ghost btn-icon"
            onClick={onClose}
            title="Close"
          >
            <Icon name="x" size={16} />
          </button>
        </div>
        <div style={{ padding: '8px 24px 20px' }}>
          {SHORTCUTS.map((s) => (
            <div
              key={s.label}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '10px 0',
                borderBottom: '1px solid var(--sp-border-soft)',
              }}
            >
              <span style={{ fontSize: 13, color: 'var(--sp-fg-1)' }}>
                {s.label}
              </span>
              <kbd
                style={{
                  background: 'var(--sp-bg-muted)',
                  border: '1px solid var(--sp-border)',
                  borderRadius: 4,
                  padding: '2px 8px',
                  fontFamily: 'inherit',
                  fontSize: 11,
                  fontWeight: 600,
                }}
              >
                {s.keys}
              </kbd>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
